import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { ToastsService } from 'projects/b2c/src/app/core/services/toasts.service';
import { FlightService } from '../../../flight.service';
import { SubSink } from 'subsink';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss']
})
export class PaymentStatusComponent implements OnInit {
  custData: any;
  orderId: string;
  private subSunk = new SubSink();
  confirmedData: any;

  constructor(private router: Router,
    private swalService: SwalService,
    private toastsService: ToastsService,
    private flightService: FlightService,
    private apiHandlerService: ApiHandlerService,
    private activatedRoute: ActivatedRoute,
    private utility: UtilityService,
  ) { }

  ngOnInit(): void {

    const customer = localStorage.getItem("flightCommitBookingResponse");
    const orderId = localStorage.getItem("orderId");
    this.orderId = orderId;
    this.custData = JSON.parse(customer);
    this.paymentCheckout();
  }


  paymentCheckout() {
    this.subSunk.sink = this.apiHandlerService.apiHandler('transactionStatus', 'post', {}, {}, {
      order_id: this.orderId,
    }).subscribe(
      (resp) => {
        if (resp.statusCode == 201 || resp.statusCode == 200) {
          if (resp.data == true) {
            this.toastsService.toast({ 'type': 'success', 'text': 'Payment successful' });
            this.callPnrTicket();
          } else {
            this.toastsService.toast({ 'type': 'error', 'text': 'Payment Failed' });
            this.router.navigate(['/flight/flight-voucher'], {
              queryParams: {
                AppReference: this.custData.AppReference
              },
            });
          }
        }
      },
      (error) => {
        this.router.navigate(['/flight/flight-voucher'], {
          queryParams: {
            AppReference: this.custData.AppReference
          },
        });
      }
    );
  }


  onReservation() {
    this.flightService.loading.next(true);
    
    if (this.flightService.isDevelopment) {
      setTimeout(() => {
        this.flightService.loading.next(false);
        this.router.navigate(['/search/flight/booking-confirm']);
      }, 3000);
    } else {
      console.log(this.flightService.CommitBookingResponse);
      
      const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
      
      this.subSunk.sink = this.apiHandlerService.apiHandler('finalBooking', 'POST', '', '', {
        created_by_id,
        ResultToken: this.custData.ResultToken,
        booking_source: this.custData.booking_source,
        AppReference: this.custData.AppReference
      }).subscribe(
        res => {
          this.flightService.loading.next(false);
          
          if (res.Status && res.data.hasOwnProperty('FinalBooking')) {
            this.flightService.FinalBookingResponse.next(res.data.FinalBooking.BookingDetails);
            
           
            this.callPnrTicket();
            
            this.flightService.bookingSource.next('');
          } else {
            this.swalService.alert.oops(res.Message);
            setTimeout(() => {
              this.router.navigate(['/flight/result']);
            }, 100);
          }
        },
        (err: HttpErrorResponse) => {
          this.flightService.loading.next(false);
          const { error } = err;
          
          // Redirect to voucher page with error handling
          this.router.navigate(['/flight/flight-voucher'], {
            queryParams: {
              AppReference: this.custData.AppReference,
            }
          });
  
          // Optional: Log the error or show an alert
          switch (error.statusCode) {
            case 400:
              this.swalService.alert.oops(error.Message);
              break;
            default:
              this.swalService.alert.oops(error.Message);
              break;
          }
        }
      );
    }
  }


  callPnrTicket() {
    const TicketData = {
      AppReference: this.custData.AppReference,
      booking_source: this.custData.booking_source,
      order_id: this.orderId
    };
  
    this.subSunk.sink = this.apiHandlerService.apiHandler('pnrRetrieve', 'post', '', '', TicketData).subscribe(
      res => {
        if (res && res.data?.FinalBooking?.BookingDetails) {
          this.confirmedData = res.data.FinalBooking.BookingDetails;
          this.utility.writeStorage("ticketCache", res.data.FinalBooking.BookingDetails, sessionStorage);
  
          // Redirect to voucher page with AppReference in queryParams
          this.router.navigate(['/flight/flight-voucher'], {
            queryParams: {
              AppReference: this.custData.AppReference,
            }
          });
        }
      },
      (err: HttpErrorResponse) => {
        // Error handling in callPnrTicket with redirection to voucher page
        this.router.navigate(['/flight/flight-voucher'], {
          queryParams: {
            AppReference: this.custData.AppReference,
          }
        });
  
        const errorMessage = err.error?.Message || 'An unexpected error occurred while retrieving PNR ticket';
        this.swalService.alert.oops(errorMessage);
      }
    );
  }
  

}
